import { MenuItem, Select, styled } from 'opensolar-ui'
import { useMemo } from 'react'
import { buildContractSelectSections } from '../../utils/entitySharingUtils'
import type { PaymentOptionContractSelectProps } from './types'
import renderGroupedContractMenuItems from './GroupedContractMenuItems'

const Row = styled('div')(
  {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginBottom: '12px',
  },
  { name: 'PaymentOptionContractSelectRow' }
)

const Label = styled('span')(
  {
    fontSize: '12px',
    fontWeight: 500,
    color: 'var(--Greys-Neutral-Grey-900, #6b6a73)',
  },
  { name: 'PaymentOptionContractSelectLabel' }
)

const EmptyOption = styled('span')(
  {
    color: '#aaa',
    fontStyle: 'italic',
  },
  { name: 'PaymentOptionContractSelectEmptyOption' }
)

const FullWidthSelect = styled(Select)(
  {
    width: '100%',
  },
  { name: 'PaymentOptionContractSelectFullWidthSelect' }
)

const PaymentOptionContractSelect = ({
  disabled,
  contracts,
  paymentOption,
  value,
  defaultContractLabel,
  onChange,
  selectMenuZIndex,
  translate,
  groupingContext,
}: PaymentOptionContractSelectProps) => {
  const sections = useMemo(() => buildContractSelectSections(contracts, groupingContext), [contracts, groupingContext])

  return (
    <Row>
      <Label>{paymentOption.title}</Label>
      <FullWidthSelect
        variant="outlined"
        disabled={disabled}
        value={value}
        onChange={(e) => {
          const nextValue = e.target.value as string
          onChange(!nextValue ? null : Number(nextValue))
        }}
        displayEmpty
        MenuProps={
          selectMenuZIndex != null ? { disableScrollLock: true, style: { zIndex: selectMenuZIndex } } : undefined
        }
        renderValue={(selected) => {
          if (!selected) {
            return <EmptyOption>{defaultContractLabel}</EmptyOption>
          }
          const contract = contracts?.find((item) => String(item.id) === String(selected))
          return contract?.title || ''
        }}
      >
        <MenuItem value="">
          <EmptyOption>{defaultContractLabel}</EmptyOption>
        </MenuItem>
        {sections
          ? renderGroupedContractMenuItems({
              sections,
              getValue: (contract) => String(contract.id),
              translate,
            })
          : contracts?.map((contract) => (
            <MenuItem key={contract.id} value={String(contract.id)}>
              {contract.title}
            </MenuItem>
          ))}
      </FullWidthSelect>
    </Row>
  )
}

export default PaymentOptionContractSelect
